module.exports = __webpack_public_path__ + "static/media/pvm-gradient.67d4b090.jpg";